import React, { useState } from "react";
import ReactPlayer from "react-player";
import { Button, Card } from "semantic-ui-react";
import Delete from "./Delete";
import "./SchoolsWatch.css";
const STWCard = (props) => {
  const [deleteId, setDelete] = useState(null);
  const [fileName, setfileName] = useState(null);
  return (
    <>
      <Card className="schools-cards">
        <div className="ifame-data">
          <div
            className="ui active embed schools"
            style={{
              background: `url(${props.data?.fileURL})`,
            }}
          >
            {props.data?.videoURL && !props.data?.fileURL && (
              <div className="embed">
                <ReactPlayer controls={true} muted url={props.data?.videoURL} />
              </div>
            )}
          </div>
        </div>
        <Card.Content>
          <Card.Header>
            <a
              href={
                props.data?.videoURL
                  ? props.data?.videoURL
                  : props.data?.fileURL
              }
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#191919" }}
            >
              {props.data?.schoolName}
            </a>
          </Card.Header>
        </Card.Content>
        {props.edit && (
          <Card.Content extra>
            <Button circular icon="edit" color="blue" onClick={props.editSTW} />
            <Button
              circular
              icon="trash"
              color="red"
              onClick={() => {
                setDelete(props.data?.id);
                setfileName(props.data?.fileName);
              }}
            />
          </Card.Content>
        )}
      </Card>
      {deleteId && (
        <Delete
          deleteId={deleteId}
          fileName={fileName}
          close={() => {
            setDelete(null);
            setfileName(null);
          }}
        />
      )}
    </>
  );
};

export default STWCard;
